/* eslint-disable react/jsx-filename-extension */
// eslint-disable-next-line import/no-extraneous-dependencies
import 'react-app-polyfill/ie11';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import numbro from 'numbro';
import deDe from 'numbro/languages/de-DE';
import './index.css';
import { defineCustomElements } from '@duetds/date-picker/dist/loader';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './styles';

numbro.registerLanguage(deDe);

defineCustomElements(window);

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
